var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLongPositionLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5439 22.3344C1.95539 22.9175 1.95097 23.8672 2.53402 24.4557C3.11707 25.0442 4.06681 25.0486 4.65532 24.4656L2.5439 22.3344ZM21.1415 21.4912L20.0833 22.5544L21.1415 21.4912ZM21.2837 21.49L20.2084 20.4442L21.2837 21.49ZM13.2813 13.8082L12.2255 12.7426L13.2813 13.8082ZM13.4222 13.8083L12.364 14.8715L13.4222 13.8083ZM4.65532 24.4656L14.337 14.8737L12.2255 12.7426L2.5439 22.3344L4.65532 24.4656ZM12.364 14.8715L20.0833 22.5544L22.1996 20.428L14.4803 12.7452L12.364 14.8715ZM22.359 22.5358L32.0748 12.5458L29.9242 10.4542L20.2084 20.4442L22.359 22.5358ZM20.0833 22.5544C20.7147 23.1828 21.7379 23.1745 22.359 22.5358L20.2084 20.4442C20.7519 19.8854 21.6471 19.8781 22.1996 20.428L20.0833 22.5544ZM14.337 14.8737C13.7904 15.4152 12.9093 15.4142 12.364 14.8715L14.4803 12.7452C13.8571 12.1249 12.8502 12.1237 12.2255 12.7426L14.337 14.8737Z",
    fill: "#02B27F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.8H31.85C31.9052 10.8 31.95 10.8448 31.95 10.9V20.25",
    stroke: "#02B27F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongPositionLight);
export default __webpack_public_path__ + "static/media/longPositionLight.cd85f7f5638a2a205e7599c7ed47e0a4.svg";
export { ForwardRef as ReactComponent };